import classnames from 'classnames';
import { ViewportStyles } from '../../../../global/types/viewport.type';
import styles from '../page.module.scss';

export type LayoutsPageHeroProps = {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  style?: ViewportStyles; // contextStyle type,
  noPadding?: boolean;
};

const PageHero = ({
  className = '',
  children,
  fullWidth = false,
  noPadding = false,
  style = { mobile: {} },
}: LayoutsPageHeroProps) => (
  <div className={classnames(styles.hero)}>
    <div className={classnames(styles['hero__bg'], className)} />
    <div
      className={classnames(
        styles['hero__children'],
        noPadding && styles['no-padding'],
        fullWidth && styles['full-width'],
      )}
      style={context.handleStyle(style)}
    >
      {children}
    </div>
  </div>
);

export default PageHero;
